import React, {createContext, useContext} from "react";
import {SecurityClient} from "../core";


const SecurityClientContext = createContext<SecurityClient<any> | undefined>(undefined);


export function useSecurityClient<TPrincipal = unknown>() {
    const client: SecurityClient<TPrincipal> = useContext(SecurityClientContext) as SecurityClient<TPrincipal>;
    if (!client) {
        throw new Error('No useSecurityClient set, use SecurityClientContext to set one')
    }
    return client
}
export interface SecurityClientProviderProps<TPrincipal> {
    client: SecurityClient<TPrincipal>;
    children?: React.ReactNode
}
export function SecurityClientProvider<TPrincipal>(props: SecurityClientProviderProps<TPrincipal>) {
    const {
        client,
        children
    } = props;

    return <SecurityClientContext.Provider value={client}>
        {children}
    </SecurityClientContext.Provider>
}
